import { default as ArrowDown } from "./ArrowDown";
import { default as ArrowLeft } from "./ArrowLeft";
import { default as ArrowRight } from "./ArrowRight";
import { default as ArrowUp } from "./ArrowUp";
import { default as Check } from "./Check";
import { default as ChevronDown } from "./ChevronDown";
import { default as ChevronLeft } from "./ChevronLeft";
import { default as ChevronRight } from "./ChevronRight";
import { default as ChevronUp } from "./ChevronUp";
import { default as Cross } from "./Cross";
import { default as Download } from "./Download";
import { default as Externallink } from "./Externallink";
import { default as Folder } from "./Folder";
import { default as History } from "./History";
import { default as Home } from "./Home";
import { default as Info } from "./Info";
import { default as Location } from "./Location";
import { default as Menu } from "./Menu";
import { default as Search } from "./Search";
import { default as Share } from "./Share";
import { default as Tag } from "./Tag";
import { default as Time } from "./Time";
import { css } from "react-emotion";
export const Icons = {
    ArrowDown,
    ArrowLeft,
    ArrowRight,
    ArrowUp,
    Check,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    Cross,
    Download,
    Externallink,
    Folder,
    History,
    Home,
    Info,
    Location,
    Menu,
    Search,
    Share,
    Tag,
    Time
};
export const Icon = ({ name, ...props }) => {
    const IconComponent = Icons[name];
    return (<IconComponent className={css `
        display: inline-block;

        /* vertically align with text */
        position: relative;
        bottom: -0.2em;

        /* SVG cross-browser fix */
        overflow: hidden;

        /* don't scale lines when scaling icon 
        & path,
        & circle,
        & polygon,
        & polyline,
        & rect {
          stroke-width: 1;
          vector-effect: non-scaling-stroke;
        } */
      `} {...props}/>);
};



// WEBPACK FOOTER //
// ./src/theme/icons/index.tsx